import { PropsWithChildren } from "react";
import { cn } from "@edusogno/lib/utils";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import { ExerciseDONE, ExerciseTODO } from "@/types";
import LayoutHeader from "@/components/v3/exercises/LayoutHeader";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

type Props = {
  type?: ExerciseType;
  timer?: number;
  title?: string;
  onClose?: () => void;
  audioSrc?: string;
  isResult?: boolean;
  onSubmit?: () => void;
  exercise?: ExerciseTODO | ExerciseDONE;
  isGrammar?: boolean;
  inProgress?: boolean;
  isCorrection?: boolean;
  onViewEssayByTutor?: () => void;
};

const ExerciseLayout = ({
  timer,
  onClose,
  children,
  audioSrc,
  exercise,
  isResult,
  isGrammar,
  isCorrection,
  onViewEssayByTutor,
  type = ExerciseType.READING,
  title = "Multiple choice and matching options (pt.2)",
}: PropsWithChildren<Props>) => (
  <DashboardContentLayout>
    <div className="flex flex-col h-full gap-4">
      <LayoutHeader
        type={type}
        title={title}
        timer={timer}
        onClose={onClose}
        audioSrc={audioSrc}
        isResult={isResult}
        exercise={exercise as ExerciseTODO}
        isGrammar={isGrammar}
        isCorrection={isCorrection}
        onViewEssayByTutor={onViewEssayByTutor}
      />

      <div
        className={cn("flex rounded-[15px] flex-col w-full relative h-full", {
          "bg-white/40 p-4": !isResult,
        })}
      >
        <div className="flex flex-col w-full relative h-full">{children}</div>
      </div>
    </div>
  </DashboardContentLayout>
);

export default ExerciseLayout;
